export default __webpack_public_path__ + "static/products-mb-clear-633a656f2e136c16e7bc69bbd741f00f.png";